import { Auth0Provider } from '@auth0/auth0-react';
import { AppState } from '@auth0/auth0-react/src/auth0-provider';

import { ApplicationConfigurationService } from '@src/core/application-configuration';
import { ProviderPropsInterface } from '@src/core/auth/components/types/provider-props.interface';
import { useCallback } from 'react';
import AuthErrorCheckerProvider from './auth-error.provider';

export const AuthProviderWithHistoryComponent = ({ children }: ProviderPropsInterface) => {
  const domain = ApplicationConfigurationService.getConfiguration().VITE_AUTH_DOMAIN;
  const clientId = ApplicationConfigurationService.getConfiguration().VITE_AUTH_CLIENT_ID;

  const onRedirectCallback = useCallback((appState: AppState) => {
    const target = appState?.returnTo ?? window.location.pathname;
    window.history.replaceState({}, document.title, target);
  }, []);

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens
    >
      <AuthErrorCheckerProvider>{children}</AuthErrorCheckerProvider>
    </Auth0Provider>
  );
};
